<div class="toast-host">
  @for (toast of toastService.toasts(); track toast.id) {
    <div
      class="draft-toast"
      [ngClass]="'draft-toast--' + toast.type"
      [class.draft-toast--persistent]="toast.persistent"
    >
      <span class="material-symbols-rounded" style="font-size: 16px">{{ toast.icon }}</span>
      <span class="draft-toast-message">{{ toast.message }}</span>
      @if (toast.action) {
        <button
          type="button"
          class="draft-toast-action"
          [attr.aria-label]="toast.action.label"
          [matTooltip]="toast.action.label ?? ''"
          (click)="onAction(toast)"
        >
          <span class="material-symbols-rounded">{{ toast.action.icon }}</span>
        </button>
      }
      @if (toast.persistent) {
        <button
          type="button"
          class="draft-toast-close"
          [attr.aria-label]="translationKeys.BUTTONS.CLOSE | translate"
          (click)="toastService.dismiss(toast.id)"
        >
          <span class="material-symbols-rounded">close</span>
        </button>
      }
    </div>
  }
</div>
